<script setup>
import { usePolicyStore } from '../stores/policyStore.js'
import AppIcon from './AppIcon.vue'
const store = usePolicyStore()
</script>
<template><div class="toast-stack" aria-live="polite"><div v-for="notice in store.notices" :key="notice.id" class="toast" :class="`toast-${notice.tone}`"><AppIcon :name="notice.tone === 'danger' || notice.tone === 'warning' ? 'warning' : 'check'" :tone="notice.tone === 'info' ? 'primary' : notice.tone" :size="20"/><span>{{ notice.message }}</span></div></div></template>
